export default [
    {
        path: '/business',
        name: 'Business',
        component: () => import('../../views/Business.vue')
    }
]
